module.exports = __webpack_public_path__ + "static/media/logo.4e545e9f.png";